// export const BASE_BACK_URL = 'http://localhost:1337'
export const BASE_BACK_URL = 'https://hansai-back.azurewebsites.net'
export const BASE_API_URL = BASE_BACK_URL + '/api'
